import React from "react";
import { useSettings } from "@/context/SettingsContext";
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Youtube, MessageCircle } from "lucide-react";

function SocialLink({ href, icon: Icon, label, testid }) {
  if (!href) return null;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className="flex items-center gap-2 px-4 py-3 border border-border rounded-sm hover:bg-foreground hover:text-background transition-colors"
      data-testid={testid}
    >
      <Icon className="w-4 h-4" />
      <span className="text-sm font-semibold">{label}</span>
    </a>
  );
}

export default function Contact() {
  const { settings } = useSettings();
  if (!settings) return <p className="text-muted-foreground">Loading...</p>;

  return (
    <div className="max-w-4xl mx-auto">
      <div className="border-b-2 border-primary pb-4 mb-8">
        <div className="font-ui text-xs uppercase tracking-[0.3em] text-muted-foreground">Contact</div>
        <h1 className="font-kannada-heading text-4xl sm:text-5xl mt-1">
          ಸಂಪರ್ಕಿಸಿ <span className="text-primary">.</span>
        </h1>
      </div>

      <p className="font-kannada-body text-lg text-muted-foreground mb-10">
        ಸುದ್ದಿ ಸಲಹೆಗಳು, ಪ್ರತಿಕ್ರಿಯೆ ಅಥವಾ ವ್ಯಾಪಾರ ವಿಚಾರಣೆಗಳಿಗಾಗಿ ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ.
      </p>

      <div className="grid gap-4 md:grid-cols-3 mb-12">
        {settings.contact_email && (
          <a
            href={`mailto:${settings.contact_email}`}
            className="border border-border p-5 rounded-sm hover:bg-muted transition-colors"
            data-testid="contact-email-card"
          >
            <Mail className="w-5 h-5 text-primary mb-3" />
            <div className="font-ui text-xs uppercase tracking-widest text-muted-foreground">Email</div>
            <div className="font-semibold mt-1 break-all">{settings.contact_email}</div>
          </a>
        )}
        {settings.contact_phone && (
          <a
            href={`tel:${settings.contact_phone}`}
            className="border border-border p-5 rounded-sm hover:bg-muted transition-colors"
            data-testid="contact-phone-card"
          >
            <Phone className="w-5 h-5 text-primary mb-3" />
            <div className="font-ui text-xs uppercase tracking-widest text-muted-foreground">Phone</div>
            <div className="font-semibold mt-1">{settings.contact_phone}</div>
          </a>
        )}
        {settings.contact_address && (
          <div className="border border-border p-5 rounded-sm" data-testid="contact-address-card">
            <MapPin className="w-5 h-5 text-primary mb-3" />
            <div className="font-ui text-xs uppercase tracking-widest text-muted-foreground">Address</div>
            <div className="font-kannada-body mt-1 text-sm leading-relaxed">
              {settings.contact_address}
            </div>
          </div>
        )}
      </div>

      {(settings.social_facebook ||
        settings.social_twitter ||
        settings.social_instagram ||
        settings.social_youtube ||
        settings.social_whatsapp) && (
        <div>
          <div className="font-ui text-xs uppercase tracking-[0.3em] text-muted-foreground mb-4">
            Follow us
          </div>
          <div className="flex flex-wrap gap-3">
            <SocialLink href={settings.social_facebook} icon={Facebook} label="Facebook" testid="social-facebook" />
            <SocialLink href={settings.social_twitter} icon={Twitter} label="Twitter / X" testid="social-twitter" />
            <SocialLink href={settings.social_instagram} icon={Instagram} label="Instagram" testid="social-instagram" />
            <SocialLink href={settings.social_youtube} icon={Youtube} label="YouTube" testid="social-youtube" />
            <SocialLink href={settings.social_whatsapp} icon={MessageCircle} label="WhatsApp" testid="social-whatsapp" />
          </div>
        </div>
      )}
    </div>
  );
}
